import { render, staticRenderFns } from "./UserAccountPurchasesDedicatedNumbers.vue?vue&type=template&id=35b0ed89&scoped=true&"
import script from "./UserAccountPurchasesDedicatedNumbers.vue?vue&type=script&lang=js&"
export * from "./UserAccountPurchasesDedicatedNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b0ed89",
  null
  
)

export default component.exports